const styles = THEME => ({
  row: {
    marginTop: '20px'
  },
  first: {
    marginTop: '0'
  }
})

export default styles
